import Vue from "vue";
import "intersection-observer";
import "amfe-flexible";
// import "@nutui/nutui/dist/nutui.css";
import Env from "@/utils/env";
import App from "./App.vue";
import router from "./router";
// import store from './store';
import GlobalDataStore from "./utils/GlobalDataStore";
import "@/assets/base.scss";

import MGSDKBridge from "@/utils/MGSDKBridge";
import WeixinSDKBridge from "@/utils/WeixinSDKBridge";

import global from '@/components/common/global'

Vue.use(global);

const getBridgeObj = () => {
  try {
    let BridgeClass = null;
    if (Env.isMgtvApp) {
      BridgeClass = MGSDKBridge;
    } else if (Env.isWeixin) {
      BridgeClass = WeixinSDKBridge;
    }
    return BridgeClass ? new BridgeClass() : null;
  } catch (error) {
    console.log(error);
  }
  return null;
};

const bridge = getBridgeObj();
const dataStore = new GlobalDataStore(bridge);
// const adReporter = new MgAdReporter(dataStore);

(async function() {
  await dataStore.init();
  Vue.config.productionTip = false;

  window.dataStore = dataStore;
  window.addEventListener("contextmenu", function(e) { e.preventDefault(); })
  Vue.mixin({
    data() {
      return {
        isDev:
          process.env.NODE_ENV === "development" ||
          /debug=1/.test(location.href),
        bridge,
        dataStore
      };
    }
  });

  new Vue({
    router,
    // store,
    render: h => h(App)
  }).$mount("#app");
})();
